
import { useState, useMemo, useCallback } from 'react';
import { ComplianceDocument } from '@/types/compliance';

export const useComplianceDocumentSelector = (documents: ComplianceDocument[]) => {
  const [selectedDocumentId, setSelectedDocumentId] = useState<string>(
    documents.length > 0 ? documents[0].id : ''
  );

  const handleDocumentChange = useCallback((id: string) => {
    setSelectedDocumentId(id);
  }, []);

  const selectedDocument = useMemo(() => 
    documents.find(doc => doc.id === selectedDocumentId) || 
    (documents.length > 0 ? documents[0] : null)
  , [documents, selectedDocumentId]);

  return {
    selectedDocumentId,
    setSelectedDocumentId: handleDocumentChange,
    selectedDocument
  };
};
